export const user = (state = null, action) => {
    switch (action.type) { // (2)
        case 'USER_REFRESH':
            return action.user;
        default:
            return state
    }
};
